import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@portal/shared/auth/authentication/src/lib/authentication.service';
import { Observable } from 'rxjs';
import { CustomHttpParams } from '@apps/vhq/src/app/modules/deviceprofile/services/custom-http-params';
import { WhiteLabelingService } from '@portal/shared/white-labeling/src/lib/services/white-labeling.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthenticationService,
    private whiteLabelingService: WhiteLabelingService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const whiteLabelingBasePath = this.whiteLabelingService.getBasePath();
    if (whiteLabelingBasePath && req.url.includes(whiteLabelingBasePath)) {
      return next.handle(req);
    }

    let eoEntityUid: string;
    let entityId: string;

    if (localStorage.getItem('organisationData')) {
      const organisation = JSON.parse(localStorage.getItem('organisationData'));
      let entityCount;
      if (localStorage.getItem('EntityCount')) {
        entityCount = localStorage.getItem('EntityCount');
      }
      if (entityCount && +entityCount === 1 && organisation.entityType === 'ESTATE_OWNER') {
        eoEntityUid = this.authService.entityId;
        entityId = this.authService.entityId;
      } else {
        eoEntityUid = this.authService.eoEntityUid;
        entityId = this.authService.entityId;
      }
    }

    let customerUniqueId: any = null;
    if (localStorage.getItem('organisationData')) {
      const orgData = localStorage.getItem('organisationData');
      JSON.parse(orgData)['businessIdentifiers'].forEach((item) => {
        if (item['identifierType'] === 'VHQ_CUSTOMER_UNIQUEID') {
          customerUniqueId = item.value;
        }
      });
    }

    const token = JSON.parse(localStorage.getItem('access_token'));
    if (!token) {
      return next.handle(req);
    }
    if (req.url.includes('action=logout') || req.url.includes('action=idFromSession')) {
      return next.handle(req);
    }
    if (
      req.url &&
      // Only intercept non-authentication request as
      // they use specific headers that should not be modified
      !req.url.includes('access_token') &&
      // The UIS IAM refresh_token grant (silent refresh) expects
      // application/x-www-form-urlencoded. Excluding it prevents the
      // Bearer/application/json rewrite below, which otherwise causes a
      // 415 Unsupported Media Type at the refreshToken endpoint.
      !req.url.includes('refreshToken') &&
      // Same for the UIS IAM authorization_code exchange: 'userAccessToken'
      // does not match 'access_token' above (camelCase), so without this the
      // call is rewritten to application/json whenever a token is already in
      // localStorage (e.g. second login in the same browser session).
      !req.url.includes('userAccessToken')
    ) {
      if (this.authService.hasTokenExpired()) {
        const redirectPath = localStorage.getItem('redirect_path');
        this.authService.logout({ redirectPath: redirectPath || '' });
        return next.handle(req);
      }

      if (req.headers.has('X-Skip-Auth')) {
        req.clone({
          headers: req.headers.delete('X-Skip-Auth'), // Remove the marker header
        });

        return next.handle(req);
      }

      // Clone the request and replace the original headers with modified ones
      let modifiedReq;
      if (req.body && req.body instanceof FormData && !(req.params instanceof CustomHttpParams)) {
        modifiedReq = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${token}`),
        });
      } else {
        if (req.params instanceof CustomHttpParams) {
          const headers: HttpHeaders = req.params.param.headers;
          if (req.params?.param?.responseType === 'text') {
            modifiedReq = req.clone({
              headers: req.headers
                .set('IDP', headers.getAll('IDP'))
                .set('Authorization', `Bearer ${token}`)
                .set('id-token', JSON.parse(localStorage.getItem('id_token')))
                .set(
                  'eoEntityUid',
                  eoEntityUid === undefined || eoEntityUid === null ? '' : eoEntityUid,
                )
                .set('entityId', entityId === undefined || entityId === null ? '' : entityId)
                .set(
                  'CustomerUniqueId',
                  customerUniqueId === undefined || customerUniqueId === null
                    ? ''
                    : customerUniqueId,
                ),
            });
            modifiedReq.responseType = 'text';
          } else {
            modifiedReq = req.clone({
              headers: req.headers
                .set(
                  'CustomerName',
                  headers.getAll('CustomerName') ? headers.getAll('CustomerName') : '',
                )
                .set('IDP', headers.getAll('IDP'))
                .set('Authorization', `Bearer ${token}`)
                .set('id-token', JSON.parse(localStorage.getItem('id_token')))
                .set(
                  'eoEntityUid',
                  eoEntityUid === undefined || eoEntityUid === null ? '' : eoEntityUid,
                )
                .set('entityId', entityId === undefined || entityId === null ? '' : entityId)
                .set(
                  'CustomerUniqueId',
                  customerUniqueId === undefined || customerUniqueId === null
                    ? ''
                    : customerUniqueId,
                ),
            });
          }
        } else {
          modifiedReq = req.clone({
            headers: req.headers
              .set('Content-type', 'application/json') // this header breaks image loading
              .set(
                'Authorization',
                req.headers?.get('Authorization')
                  ? req.headers?.get('Authorization')
                  : `Bearer ${token}`,
              )
              .set(
                'CustomerUniqueId',
                customerUniqueId === undefined || customerUniqueId === null ? '' : customerUniqueId,
              ),
          });
        }
      }
      // send cloned request with header to the next handler.z
      return next.handle(modifiedReq);
    }
    return next.handle(req);
  }
}
